import { render, staticRenderFns } from "./CustomerCommentPanel.vue?vue&type=template&id=6c60635e&scoped=true"
import script from "./CustomerCommentPanel.vue?vue&type=script&lang=js"
export * from "./CustomerCommentPanel.vue?vue&type=script&lang=js"
import style0 from "./CustomerCommentPanel.vue?vue&type=style&index=0&id=6c60635e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c60635e",
  null
  
)

export default component.exports